import script from "./ElaAdminSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ElaAdminSidebar.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__